import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {useAuth} from "hooks/useAuth";
import { Link} from "react-router-dom";

const BrioLogoFooter = ({open = true, size = "large", imageSize} : {open? : boolean, size? : "small" | "large", imageSize?: number}) => {
    const {user} = useAuth();

    return (
        <Link to="/">
            <Box
                height="30px"
                display="flex"
                alignItems="center"
                sx={{
                    flexDirection: "row",
                    textAlign: "left",
                    paddingTop: 0,
                    flexWrap: {xs: "wrap", lg: "nowrap"},
                }}
            >
                {open ? (
                    <>
                        <img
                            src={user.theme === "light" ? "/images/logo-brio-blue.svg" : "/images/logo-brio-white.svg"}
                            height={imageSize ?? "30px"}
                            style={{width: "auto"}}
                            alt="Brio Platforma de Testare Fundamentată Științific"
                        />
                        {size === "large" && (
                            <Box sx={{marginLeft: 2, marginTop: "2px"}}>
                                <Typography component="div" variant="small" color="secondary.light">
                                    PLATFORMA DE TESTARE
                                </Typography>
                                <Typography component="div" variant="small" color="secondary.light">
                                    FUNDAMENTATĂ ȘTIINȚIFIC
                                </Typography>
                            </Box>
                        )}
                    </>
                ) : (
                    <Box sx={{textAlign: "center", width: "100%"}}>

                    <img
                        src={"/images/favicons/apple-icon.png"}
                        height="30px"
                        style={{width: "auto"}}
                        alt="Brio Platforma de Testare Fundamentată Științific"
                    />
                    </Box>
                )}


            </Box>
        </Link>
    );
};

export default BrioLogoFooter;
